
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next-level-power",
      function () {
        return require("private-next-pages/next-level-power/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/next-level-power"])
      });
    }
  